import { Heading } from '@sparemin/blockhead';
import React from 'react';
import SocialShareModalBody from 'containers/SocialShareModal/SocialShareModalBody';

export type FacebookPermissionStepProps = {};

const FacebookPermissionStep: React.FC<FacebookPermissionStepProps> = () => {
  return (
    <SocialShareModalBody showRegenerateTextButton={false}>
      <Heading level={2} align="center">
        We can't post your video unless you allow us to manage and publish to
        your pages.
      </Heading>
    </SocialShareModalBody>
  );
};

export default FacebookPermissionStep;
